import { useGetNegotiationDetailQuery } from "../../../redux/api/negotiationsApiSlice";
import { useParams } from "react-router-dom";
import { skipToken } from "@reduxjs/toolkit/dist/query";

export function useGetAIThoughts() {
  const { id } = useParams()

  const { data: negotiationData } = useGetNegotiationDetailQuery(id ?? skipToken)

  return (itemName: string) => {
    if (
      negotiationData
      && negotiationData.lob.ai_enabled
      && negotiationData.negotiation_analysis
    ) {
      return negotiationData.negotiation_analysis.thought_fields.includes(itemName)
    }
    return false
  }
}
